// Chapitre « Je coache » : suivi des élèves, programmes, consignes.
import React from "react";
import Rangee from "./Rangee";
import { IconePlanche } from "../../site/Icones";
import ApercuEleves from "../../site/apercus/ApercuEleves";
import ApercuProgramme from "../../site/apercus/ApercuProgramme";
import ApercuConsigne from "../../site/apercus/ApercuConsigne";
import { ApercuNotificationFiche } from "../../site/apercus/ApercuPetitesCartes";

export default function ChapitreCoach() {
	return (
		<section className="gs-section" id="coachs" aria-labelledby="gs-chap-coach">
			<div className="gs-quadrillage gs-quadrillage--section" />
			<div className="gs-conteneur">
				<div className="gs-tete-section">
					<span className="gs-repere">
						<i>
							<IconePlanche taille={18} />
						</i>
						Je coache
					</span>
					<h2 id="gs-chap-coach" className="gs-h2">
						Tes élèves, <span className="gs-accent">sur un seul écran.</span>
					</h2>
					<p className="gs-texte gs-texte--grand">
						Programme à l'avance, repère qui décroche, ajuste à distance : depuis ton téléphone ou ton ordinateur,
						sans y passer tes dimanches.
					</p>
				</div>

				<Rangee
					surtitre="Suivi"
					titre="Vois qui progresse et qui décroche"
					texte="Régularité, progression, dernière séance : tout ton groupe sur un écran, sur le web comme dans l'app. Celui qui décroche ressort avant d'abandonner."
					points={[
						"Rapport hebdo de chaque élève",
						"Statistiques détaillées par exercice",
						"Jusqu'à 100 élèves avec GymNote Pro",
					]}
				>
					<ApercuEleves />
				</Rangee>

				<Rangee
					inverse
					surtitre="Programmes"
					titre="Programme des semaines en quelques clics"
					texte="Construis une séance type ou un programme, choisis les jours, et toutes les séances arrivent dans l'app de ton élève, charges comprises."
					points={[
						"Modèles réutilisables",
						"Charges en pourcentage du max ou fixées",
						"Plusieurs élèves d'un coup",
					]}
				>
					<ApercuProgramme />
				</Rangee>

				<Rangee
					surtitre="Consignes"
					titre="Ajuste une séance, ton élève est prévenu"
					texte="Fixe l'objectif d'une série, écris une consigne : ton élève reçoit une notification et retrouve tout dans sa fiche Gym'Coach."
					points={["Objectifs par série et consignes écrites", "Notification dans l'app de l'élève", "Depuis le web ou depuis l'app"]}
				>
					<div className="gs-a-duo">
						<ApercuConsigne />
						<ApercuNotificationFiche className="gs-a-duo-banniere" />
					</div>
				</Rangee>
			</div>
		</section>
	);
}
